"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../utils/constants");
var muiRewindFill16 = {
    paths: [
        {
            path: 'M9,0 C9.55228475,0 10,0.44771525 10,1 C10,1.36378233 9.80575091,1.68219536 9.51531779,1.85717402 L2.88679623,6 L9.51531779,10.142826 C9.80575091,10.3178046 10,10.6362177 10,11 C10,11.5522847 9.55228475,12 9,12 C8.79978297,12 8.61330893,11.9411593 8.45692691,11.839827 L0.484682211,6.85717402 C0.194249089,6.68219536 0,6.36378233 0,6 C0,5.63621767 0.194249089,5.31780464 0.484682211,5.14282598 L8.45692691,0.160173039 C8.61330892,0.0588406979 8.79978297,0 9,0 Z M14.4495326,0.249285062 C14.8026983,-0.0831647351 15.3743228,-0.0840780996 15.73182,0.252449121 C15.9085248,0.418788756 15.9967673,0.637049998 15.9977252,0.854917416 C15.998692,1.07477306 15.991983,10.9065986 15.9994787,11.1145817 C16.0076959,11.3425817 15.9187754,11.5736958 15.73182,11.7496848 C15.3767979,12.083882 14.7991299,12.0819395 14.4495326,11.7528488 L14.4495326,11.7528488 L6,6 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Rewind',
    width: 16,
    height: 12,
};
var muiRewindFill = {
    base: muiRewindFill16,
    smIcon: muiRewindFill16,
};
exports.muiRewindFill = muiRewindFill;
//# sourceMappingURL=rewindFill.js.map